module.exports = __webpack_public_path__ + "img/红包弹窗1@2x.57718c5b.png";